import type { JsonKind, SafeJsonEditorTheme } from '../types';

// Matches Ant Design v4's actual preset <Tag color="..."> three-tone system
// (text color + tinted background + mid-tone border) exactly, rather than a
// flat colored-outline-on-white look, so these type tags read as genuine
// AntD tags rather than a visually distinct, flatter component.
export const defaultTheme: SafeJsonEditorTheme = {
  colors: {
    object: '#d46b08',
    array: '#08979c',
    string: '#531dab',
    number: '#096dd9',
    boolean: '#389e0d',
    null: 'rgba(0, 0, 0, 0.65)',
  },
  background: {
    object: '#fff7e6',
    array: '#e6fffb',
    string: '#f9f0ff',
    number: '#e6f7ff',
    boolean: '#f6ffed',
    null: '#fafafa',
  },
  border: {
    object: '#ffd591',
    array: '#87e8de',
    string: '#d3adf7',
    number: '#91d5ff',
    boolean: '#b7eb8f',
    null: '#d9d9d9',
  },
};

/** Builds the inline style for a type tag (text/background/border) from the theme. */
export const getTypeTagStyle = (
  theme: SafeJsonEditorTheme,
  type: JsonKind,
): { color: string; backgroundColor: string; borderColor: string } => ({
  color: theme.colors[type],
  backgroundColor: theme.background[type],
  borderColor: theme.border[type],
});

